import { render, staticRenderFns } from "./channelingAnalysis.vue?vue&type=template&id=3b7b0fcd&scoped=true"
import script from "./channelingAnalysis.vue?vue&type=script&lang=js"
export * from "./channelingAnalysis.vue?vue&type=script&lang=js"
import style0 from "./channelingAnalysis.vue?vue&type=style&index=0&id=3b7b0fcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b0fcd",
  null
  
)

export default component.exports